import ContentSection from './ContentSection'
import { getIcon } from '../../shared/icons/getIcon'

const ContentInfoSection = ({ props, style }) => {
  const { icon, image, items, subtitle, text, title } = props
  return (
    <section aria-label={title} style={style}>
      <ContentSection
        icon={getIcon(icon)}
        subtitle={subtitle}
        title={title}
        text={text}
        imageSrc={image}
        items={items}
      />
    </section>
  )
}

export default ContentInfoSection
